// src/pages/Inf/infTourConfig.js

import i18n from "../../../i18n/config";

export const infTourSteps = [
	{
		popover: {
			title: i18n.t("tours.inf.welcome"),
			description: i18n.t("tours.inf.welcomeDesc"),
			side: "over",
		},
	},
	{
		element: 'input[placeholder*="Search"]',
		popover: {
			title: i18n.t("tours.inf.search"),
			description: i18n.t("tours.inf.searchDesc"),
			position: "bottom",
		},
	},
	{
		element: ".inf-list-scroll",
		popover: {
			title: i18n.t("tours.inf.list"),
			description: i18n.t("tours.inf.listDesc"),
			position: "top",
		},
	},
	{
		element: ".phc-row",
		popover: {
			title: i18n.t("tours.inf.card"),
			description: i18n.t("tours.inf.cardDesc"),
			position: "left",
		},
	},
	{
		popover: {
			title: i18n.t("tours.inf.done"),
			description: i18n.t("tours.inf.doneDesc"),
			side: "over",
		},
	},
];
